/**
 * Lightweight route path strings extracted from checkout-routes.js and tasks-routes.js.
 * Import this instead of the full route configs when you only need path strings,
 * to avoid pulling heavyweight component imports into your bundle.
 */

export const CHECKOUT_ROUTE_PATHS = {
    basicDetails: "basic-details",
    deliveryDetails: "delivery-details",
    tradeInIntro: "trade-in-intro",
    carCover: "warranty-cover",
    addOns: "add-ons",
    paymentOptions: "payment-options",
    summary: "summary",
    ffOverview: "finance-first-basic-details"
};

export const TEST_DRIVE_ROUTE_PATHS = {
    basicDetails: "basic-details"
};

export const TEST_DRIVE_V2_ROUTE_PATHS = {
    preliminary: "preliminary",
    basicDetails: "basic-details",
    finance: "finance",
    getFinancing: "get-financing",
    loanDetails: "loan-details",
    employmentDetails: "employment-details",
    personalDetails: "personal-details",
    pollOffers: "poll-offers",
    loanCalculator: "loan-calculator",
    selectOffer: "select-offer",
    selectDay: "select-day",
    bookingConfirmed: "confirmation"
};

export const TASKS_ROUTE_PATHS = {
    addOns: "add-ons",
    viewTask: "tasks",
    driverLicence: "user-id"
};
